import createIcon from '@/lib/create-icon'

const ShootingStarIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'>
    <path
      d='M15.0023 15.0013L11.2507 11.2497M11.2507 15.7516L9.75007 14.2509M15.7526 11.2497L14.2519 9.74907M8.11928 11.4818L8.91686 8.91589L11.4828 8.1183C11.696 8.05203 11.853 7.87048 11.888 7.64997C11.9229 7.42947 11.8296 7.20826 11.6473 7.07935L9.45347 5.52788L9.48781 2.84109C9.49067 2.61785 9.36654 2.41235 9.16762 2.311C8.9687 2.20964 8.72949 2.23001 8.55057 2.36353L6.39711 3.97055L3.85243 3.10763C3.64101 3.03593 3.40721 3.09048 3.24935 3.24835C3.09148 3.40621 3.03693 3.64001 3.10863 3.85143L3.97155 6.39611L2.36451 8.54959C2.23099 8.72851 2.21062 8.96772 2.31198 9.16664C2.41333 9.36556 2.61883 9.48969 2.84206 9.48684L5.52886 9.45249L7.08033 11.6463C7.20924 11.8286 7.43045 11.9219 7.65095 11.887C7.87145 11.8521 8.05301 11.695 8.11928 11.4818Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>,
  'ShootingStarIcon'
)

export default ShootingStarIcon
